import React, { useContext, Suspense, useEffect, useRef, useState } from 'react'
import { useLocation, Outlet, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Header from '../components/Header'
import Main from '../containers/Main'
import FallbackLoading from '../components/loader/FallbackLoading'
import TopProgressBar from '../components/loader/TopProgressBar'
import { SidebarContext } from '../context/SidebarContext'
import Sidebar from '../components/SideBar'
import ErrorBoundary from '../components/ErrorBoundary'

import { getSites } from '../redux/api/siteAPI'
import ChatBox from '../components/chat/ChatBox'


function Layout() {
  const { isSidebarOpen, closeSidebar } = useContext(SidebarContext)
  const [initLoading, setInitLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [disableSideBar, setDisableSideBar] = useState(false);
  const sitesRefreshToken = useSelector(state => state.sites?.refreshToken);
  const hasLoadedOnce = useRef(false);

  const navigate = useNavigate();

  let location = useLocation()

  useEffect(() => {
    closeSidebar()
  }, [location])
  useEffect(() => {
    fetchSites()
  }, [sitesRefreshToken])

  const fetchSites = async () => {
    // Only block the whole layout behind a full-screen loader on the very
    // first load. Later refreshes (e.g. sitesRefreshToken changing) show a
    // slim top progress bar instead, so the sidebar/header/content stay put.
    if (hasLoadedOnce.current) {
      setIsRefreshing(true)
    } else {
      setInitLoading(true)
    }

    try {
      const { error, data } = await getSites();
      if (error) {
        throw new Error(error);
      }
      if (data) {
        setDisableSideBar(data.sites.length < 1)
      }
    } catch (err) {
      console.error(err);
    } finally {
      hasLoadedOnce.current = true;
      setInitLoading(false)
      setIsRefreshing(false)
    }
  };

  if (initLoading)
    return <FallbackLoading />

  return (
    <div className={`flex min-h-screen bg-white font-roboto ${isSidebarOpen && 'overflow-hidden'}`}>
      {isRefreshing && <TopProgressBar />}
      <Sidebar initLoading={initLoading} />
      {disableSideBar && (
        <div className="absolute inset-0  pointer-events-auto"></div>
      )}
      <div className="flex flex-col w-full">
        <Header />
        <Main>
          {/* Keyed by pathname: a crash on one page shows a recoverable
              fallback right here (sidebar/header stay usable) and clears
              itself as soon as the user navigates to another route. */}
          <ErrorBoundary resetKey={location.pathname}>
            <Suspense fallback={<FallbackLoading />}>
              <Outlet />
            </Suspense>
          </ErrorBoundary>
          {/* <ChatBox /> */}
        </Main>
      </div>
    </div>
  )
}

export default Layout